module.exports = __webpack_public_path__ + "img/67.6339291.png";